<p-toast></p-toast>
<h3 class="header-upload pt-3" mat-dialog-title>{{data.isEditable ? 'Update' : 'Add'}} a {{data.type === employeeType.StoreEmployees ? 'Store Employee' : 'Web Admin'}}</h3>
<div *ngIf="loading" style="text-align: center; padding: 30px;">
    <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                    fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
</div>
<span class="desciption-upload" mat-dialog-title>
        Ensure your {{data.type === employeeType.StoreEmployees ? 'employee' : 'web admin'}}'s information is accurate before saving.
</span>
<mat-dialog-content *ngIf="!loading">
    <mat-stepper linear #stepper (selectionChange)="getStep($event)">
            <mat-step [stepControl]="employeeDetailsForm">
                <ng-template matStepLabel>Employee Details</ng-template>
                    <form [formGroup]="employeeDetailsForm">
                        <div class="flex mt-3">
                            <div class="flex-1">
                                <span class="section-title">Employee Details</span>
                                <div class="flex mt-3">
                                    <div class="flex-1 mr-3">
                                        <mat-form-field class="w-100">
                                            <mat-label>First Name</mat-label>
                                            <input matInput placeholder="First Name" formControlName="FirstName" required>
                                            <mat-hint class="error-message" *ngIf="employeeDetailsForm.controls['FirstName'].invalid && (employeeDetailsForm.controls['FirstName'].touched || employeeDetailsForm.controls['FirstName'].dirty)">
                                                First Name is required.
                                            </mat-hint>
                                        </mat-form-field>
                                    </div>
                                    <div class="flex-1">
                                        <mat-form-field class="w-100">
                                            <mat-label>Last Name</mat-label>
                                            <input matInput placeholder="Last Name" formControlName="LastName" required>
                                            <mat-hint class="error-message" *ngIf="employeeDetailsForm.controls['LastName'].invalid && (employeeDetailsForm.controls['LastName'].touched || employeeDetailsForm.controls['LastName'].dirty)">
                                                Last Name is required.
                                            </mat-hint>
                                        </mat-form-field>
                                    </div> 
                                </div>
                                <div class="flex">
                                    <div class="flex-1">
                                        <mat-form-field class="w-100">
                                            <mat-label>Company Email</mat-label>
                                            <input matInput placeholder="Company Email" formControlName="Email" required>
                                            <mat-hint class="error-message" *ngIf="employeeDetailsForm.controls['Email'].errors?.['required'] && (employeeDetailsForm.controls['Email'].touched || employeeDetailsForm.controls['Email'].dirty)">
                                                Email is required.
                                            </mat-hint>
                                            <mat-hint class="error-message" *ngIf="employeeDetailsForm.controls['Email'].errors?.['email']">
                                                Email is invalid.
                                            </mat-hint>
                                        </mat-form-field>
                                    </div> 
                                </div>
                            </div>
                        </div>
                    </form>

            </mat-step>
            <mat-step [stepControl]="roleForm">
                <ng-template matStepLabel>Role</ng-template>
                <p-scrollPanel [style]="{height: 'calc(100vh - 550px)'}">
                    <form [formGroup]="roleForm">
                        <span class="section-title">Select employer's role</span>
                        <div class="flex mt-3">
                            <mat-form-field class="w-6">
                                <mat-label>Role</mat-label>
                                <mat-select required formControlName="Role" [(value)]="roleForm.controls['Role'].value">
                                    @for (role of (data.type === employeeType.StoreEmployees ? storeRoles : adminRoles); track role) {
                                    <mat-option [value]="role.id">{{role.name}}</mat-option>
                                    }
                                </mat-select>
                                <mat-hint class="error-message" *ngIf="roleForm.controls['Role'].invalid && (roleForm.controls['Role'].touched || roleForm.controls['Role'].dirty)">
                                    Role is required.
                                </mat-hint>
                            </mat-form-field>
                        </div>
                        <div *ngIf="data.type === employeeType.StoreEmployees" class="flex mb-2">
                            <span class="info-text">Having trouble? <a target="_blank" (click)="getRolePermissions()">See Role permission</a></span>
                        </div>
                        <div class="flex">
                            <span class="info-text">Required form labels ends with an *</span>
                        </div>
                    </form>
                </p-scrollPanel>
            </mat-step>
            <mat-step *ngIf="!data.isEditable" [stepControl]="timeForm">
                <ng-template matStepLabel>Email</ng-template>
                <p-scrollPanel [style]="{height: 'calc(100vh - 550px)'}">
                    <form [formGroup]="timeForm">
                        <p class="description-location mt-3">
                            Email credentials to the employee’s designated email now or at a scheduled date & time.
                        </p>
                        <span class="section-title">Send Email</span>
                        <div class="flex mt-3">
                            <mat-form-field class="w-6" *ngIf="timeForm.controls['Time'].value === 'Now' || timeForm.controls['Time'].value === '24 Hours' || timeForm.controls['Time'].value === ''">
                                <mat-label>Select Time</mat-label>
                                <mat-select required formControlName="Time">
                                    @for (time of timeList; track time) {
                                    <mat-option [value]="time">{{time}}</mat-option>
                                    }
                                </mat-select>
                                <mat-hint class="error-message" *ngIf="timeForm.controls['Time'].invalid && (timeForm.controls['Time'].touched || timeForm.controls['Time'].dirty)">
                                    Time is required.
                                </mat-hint>
                            </mat-form-field>
                            <p-calendar 
                                class="custom-field"
                                *ngIf="timeForm.controls['Time'].value !== '' && timeForm.controls['Time'].value !== 'Now' && timeForm.controls['Time'].value !== '24 Hours'"
                                appendTo="body"
                                placeholder="Select Time"
                                [readonlyInput]="true"
                                formControlName="Time"
                                inputId="calendar-12h" 
                                [minDate]="minDate"
                                [showTime]="true" 
                                [hourFormat]="'12'" />

                            <button class="custom-btn" *ngIf="timeForm.controls['Time'].value !== '' && timeForm.controls['Time'].value !== 'Now' && timeForm.controls['Time'].value !== '24 Hours'" mat-icon-button (click)="resetTime()"><mat-icon>close</mat-icon></button>
                        </div>
                        <div class="flex">
                            <span class="info-text">Required form labels ends with an *</span>
                        </div>
                    </form>
                </p-scrollPanel>
            </mat-step>
    </mat-stepper>
</mat-dialog-content>
<mat-dialog-actions class="pr-4 pb-4" align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button class="next-btn" *ngIf="!data.isEditable"
        [ngClass]="selectedIndex === 2 && timeForm.invalid || timeForm.controls['Time'].value === 'Custom' ? 'btn-disabled' : ''"
        [disabled]="(selectedIndex === 2 && timeForm.invalid || timeForm.controls['Time'].value === 'Custom')" mat-button 
        (click)="nextStep('create')">{{selectedIndex === 2 ? 'Add Employee' : 'Next'}}</button>
    <button class="next-btn" *ngIf="data.isEditable"
        [ngClass]="selectedIndex === 1 && selectedStores.length < 1 ? 'btn-disabled' : ''"
        [disabled]="selectedIndex === 1 && selectedStores.length < 1" mat-button 
        (click)="nextStep('update')">{{selectedIndex === 1 ? 'Update Employee' : 'Next'}}</button>
</mat-dialog-actions>
